/**
 * PR44: Command Registry — 20 commands, all preview-only, no live execution
 * @version 0.1.11
 * @safety dryRunOnly=true, realExecutionEnabled=false for all entries
 */
export const COMMAND_REGISTRY = [
    {
        id: "search-web",
        name: "Search Web",
        category: "research",
        version: "0.1.0",
        description: "Preview-only web search command — no real network calls",
        relatedAgentIds: ["researcher-agent"],
        relatedSkillIds: ["web-search"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "summarize-content",
        name: "Summarize Content",
        category: "research",
        version: "0.1.0",
        description: "Preview-only content summarization command",
        relatedAgentIds: ["researcher-agent"],
        relatedSkillIds: ["web-search", "content-writing"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "write-article",
        name: "Write Article",
        category: "writing",
        version: "0.1.0",
        description: "Preview-only article writing command",
        relatedAgentIds: ["writer-agent"],
        relatedSkillIds: ["content-writing"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "write-email",
        name: "Write Email",
        category: "writing",
        version: "0.1.0",
        description: "Preview-only email writing command",
        relatedAgentIds: ["writer-agent"],
        relatedSkillIds: ["content-writing"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "generate-code",
        name: "Generate Code",
        category: "coding",
        version: "0.1.0",
        description: "Preview-only code generation command",
        relatedAgentIds: ["coder-agent"],
        relatedSkillIds: ["code-generation"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "refactor-code",
        name: "Refactor Code",
        category: "coding",
        version: "0.1.0",
        description: "Preview-only code refactoring command",
        relatedAgentIds: ["coder-agent"],
        relatedSkillIds: ["code-generation", "coding-standards"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "analyze-data",
        name: "Analyze Data",
        category: "analysis",
        version: "0.1.0",
        description: "Preview-only data analysis command",
        relatedAgentIds: ["analyst-agent"],
        relatedSkillIds: ["data-analysis"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "visualize-data",
        name: "Visualize Data",
        category: "analysis",
        version: "0.1.0",
        description: "Preview-only data visualization command",
        relatedAgentIds: ["analyst-agent"],
        relatedSkillIds: ["data-analysis"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "create-plan",
        name: "Create Plan",
        category: "planning",
        version: "0.1.0",
        description: "Preview-only task planning command",
        relatedAgentIds: ["planner-agent"],
        relatedSkillIds: ["task-planning"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "orchestrate-agents",
        name: "Orchestrate Agents",
        category: "planning",
        version: "0.1.0",
        description: "Preview-only agent orchestration command",
        relatedAgentIds: ["orchestrator-agent"],
        relatedSkillIds: ["task-planning"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "generate-tests",
        name: "Generate Tests",
        category: "testing",
        version: "0.1.0",
        description: "Preview-only test generation command",
        relatedAgentIds: ["tester-agent"],
        relatedSkillIds: ["test-generation"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "run-tests",
        name: "Run Tests",
        category: "testing",
        version: "0.1.0",
        description: "Preview-only test execution command — no real execution",
        relatedAgentIds: ["tester-agent"],
        relatedSkillIds: ["test-generation"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "design-ui",
        name: "Design UI",
        category: "design",
        version: "0.1.0",
        description: "Preview-only UI design command",
        relatedAgentIds: ["designer-agent"],
        relatedSkillIds: ["ui-design"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "create-lesson",
        name: "Create Lesson",
        category: "teaching",
        version: "0.1.0",
        description: "Preview-only lesson creation command",
        relatedAgentIds: ["teacher-agent"],
        relatedSkillIds: ["tutoring"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "review-code",
        name: "Review Code",
        category: "review",
        version: "0.1.0",
        description: "Preview-only code review command",
        relatedAgentIds: ["code-reviewer"],
        relatedSkillIds: ["code-review"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "audit-security",
        name: "Audit Security",
        category: "security",
        version: "0.1.0",
        description: "Preview-only security audit command",
        relatedAgentIds: ["code-reviewer"],
        relatedSkillIds: ["security-review"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "write-docs",
        name: "Write Documentation",
        category: "documentation",
        version: "0.1.0",
        description: "Preview-only documentation writing command",
        relatedAgentIds: ["writer-agent", "coder-agent"],
        relatedSkillIds: ["coding-standards", "content-writing"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "explain-concept",
        name: "Explain Concept",
        category: "teaching",
        version: "0.1.0",
        description: "Preview-only concept explanation command",
        relatedAgentIds: ["teacher-agent", "assistant-agent"],
        relatedSkillIds: ["tutoring", "general-assistance"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "check-standards",
        name: "Check Coding Standards",
        category: "review",
        version: "0.1.0",
        description: "Preview-only coding standards check command",
        relatedAgentIds: ["code-reviewer", "coder-agent"],
        relatedSkillIds: ["coding-standards", "code-review"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
    {
        id: "general-help",
        name: "General Help",
        category: "general",
        version: "0.1.0",
        description: "Preview-only general assistance command",
        relatedAgentIds: ["assistant-agent"],
        relatedSkillIds: ["general-assistance"],
        dryRunOnly: true, previewOnly: true, realExecutionEnabled: false,
        requireOwnerApproval: true, auditEnabled: true,
        networkAllowed: false, productionDbAllowed: false,
    },
];
export function getCommandById(id) {
    return COMMAND_REGISTRY.find(c => c.id === id);
}
export function listCommandIds() {
    return COMMAND_REGISTRY.map(c => c.id);
}
export function getCommandsForAgent(agentId) {
    return COMMAND_REGISTRY.filter(c => c.relatedAgentIds.includes(agentId));
}
export function getCommandsForSkill(skillId) {
    return COMMAND_REGISTRY.filter(c => c.relatedSkillIds.includes(skillId));
}
export function assertNoLiveCommands() {
    for (const cmd of COMMAND_REGISTRY) {
        if (cmd.realExecutionEnabled !== false)
            throw new Error(`SAFETY VIOLATION: Command ${cmd.id} has realExecutionEnabled=true`);
        if (cmd.dryRunOnly !== true)
            throw new Error(`SAFETY VIOLATION: Command ${cmd.id} has dryRunOnly=false`);
    }
}
export function validateCommandRegistry() {
    const errors = [];
    const ids = new Set();
    for (const cmd of COMMAND_REGISTRY) {
        if (ids.has(cmd.id))
            errors.push(`Duplicate command id: ${cmd.id}`);
        ids.add(cmd.id);
        if (!cmd.id)
            errors.push("Command missing id");
        if (!cmd.name)
            errors.push(`Command ${cmd.id} missing name`);
        if (!cmd.category)
            errors.push(`Command ${cmd.id} missing category`);
        if (!cmd.version)
            errors.push(`Command ${cmd.id} missing version`);
        if (!cmd.description)
            errors.push(`Command ${cmd.id} missing description`);
        if (!Array.isArray(cmd.relatedAgentIds))
            errors.push(`Command ${cmd.id} missing relatedAgentIds`);
        if (!Array.isArray(cmd.relatedSkillIds))
            errors.push(`Command ${cmd.id} missing relatedSkillIds`);
        if (cmd.realExecutionEnabled !== false)
            errors.push(`Command ${cmd.id}: realExecutionEnabled must be false`);
        if (cmd.dryRunOnly !== true)
            errors.push(`Command ${cmd.id}: dryRunOnly must be true`);
        if (cmd.networkAllowed !== false)
            errors.push(`Command ${cmd.id}: networkAllowed must be false`);
        if (cmd.productionDbAllowed !== false)
            errors.push(`Command ${cmd.id}: productionDbAllowed must be false`);
    }
    return { valid: errors.length === 0, errors };
}
//# sourceMappingURL=registry.js.map